import { render, staticRenderFns } from "./card-timeline-yuri.vue?vue&type=template&id=36d9d406&scoped=true&"
import script from "./card-timeline-yuri.vue?vue&type=script&lang=js&"
export * from "./card-timeline-yuri.vue?vue&type=script&lang=js&"
import style0 from "./card-timeline-yuri.vue?vue&type=style&index=0&id=36d9d406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d9d406",
  null
  
)

export default component.exports